import { Action } from 'typescript-fsa'
import { Dispatch } from 'redux'
import { connect } from 'react-redux'
import { AppState } from 'redux/store'
import { actions as applicationActions, ApplicationState } from 'redux/modules/application'
import Screen from './PrivacyPolicy'

export interface PrivacyPolicyActions {
  load: () => Action<void>
}

export interface PrivacyPolicyStoreStates {
  application: ApplicationState
}

function mapDispatchToProps(dispatch: Dispatch<Action<any>>): PrivacyPolicyActions {
  return {
    load: () => dispatch(applicationActions.loadPrivacyPolicy()),
  }
}

function mapStateToProps(appState: AppState): PrivacyPolicyStoreStates {
  return { application: appState.application }
}

export default connect(mapStateToProps, mapDispatchToProps)(Screen)
